import type { OrderConfirmationMetricId } from '@/types/workflowSummary'

export const WORKFLOW_METRIC_COPY: Record<
  OrderConfirmationMetricId,
  { label: string; description: string }
> = {
  todo: {
    label: 'Awaiting validation',
    description: 'Order confirmations that need validation',
  },
  pending: {
    label: 'Pending',
    description: 'Orders not yet fully confirmed by supplier',
  },
}
